import {
    Avatar, Box, Button, Card, CardActions, CardContent, CardMedia, Stack, Typography
} from "@material-ui/core";
import { Link } from "react-router-dom";
import sample from "./img/sample.png";
import seenIcon from "./img/seen.svg";
import voteIcon from "./img/vote.svg";
import styles from "./index.module.css";


export default function IdealCard({ teamName, members, description, vote, seen }) {
    const xl = document.documentElement.clientWidth >= 1440;
    return (<>
        <Card sx={{ maxWidth: "356px", width: "24.72vw", borderRadius: "20px", margin: "1vw" }}>
            <CardMedia component="img" image={sample} />
            <CardContent>
                <Typography gutterBottom variant="h5" color="#A6A6A6" component="div">
                    {teamName}
                </Typography>
                <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={2}
                >
                    {members.map((member) => {
                        return (
                            <Stack alignItems="center" spacing={0.5}>
                                <Link
                                    to={{ pathname: "/Profile_show", state: { id: member.id } }}
                                    style={{ pointerEvents: !member.id && "none" }}
                                >
                                    <Avatar sx={{
                                        maxWidth: "33px",
                                        maxHeight: "33px",
                                        width: "2.3vw",
                                        height: "2.3vw"
                                    }} src={member.img} alt="avatar" /></Link>
                                <Typography color="#A6A6A6" fontSize={xl ? "10px" : "0.7vw"}>{member.name}</Typography>
                            </Stack>
                        );
                    })}
                </Stack>
                <Typography
                    marginTop="1vw"
                    variant="body2"
                    color="text.secondary"
                    className={styles.description}
                >
                    {description}
                </Typography>
            </CardContent>
            <Box sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between"
            }}>
                <CardActions>
                    <Button size="small">Share</Button>
                    <Button size="small">Learn More</Button>
                </CardActions>
                <Stack marginRight="2vw" direction="row" spacing={1.5} alignItems="center">
                    <img src={voteIcon} alt="vote" style={{ width: "1.3vw", maxWidth: "20px" }} />
                    <Typography fontSize={xl ? "10px" : "0.7vw"} color="#BEBEBE">{vote || 0}</Typography>

                    <img src={seenIcon} alt="seen" style={{ width: "1.3vw", maxWidth: "20px" }} />
                    <Typography fontSize={xl ? "10px" : "0.7vw"} color="#BEBEBE">{seen}</Typography>
                </Stack>
            </Box>
        </Card>
    </>);
}